module.exports = __webpack_public_path__ + "static/media/20180523-LCS-028-21.93051a34.jpg";